import { setToken, setupAxiosInterceptor } from '@cw-elements/config';
import { Layout } from 'antd';
import { StorageKeyOptionsEnum } from 'common/utils/local-data/local-data.constant';
import {
  getLocalData,
  setLocalData,
} from 'common/utils/local-data/local-data.utils';
import { useTrackingEnrichProperties } from 'common/utils/tracking/tracking.hook';
import dayjs from 'dayjs';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';
import { api } from 'src/api.config';
import { useAuth } from 'src/auth/auth.provider';
import { MediaQuery } from 'theme';

import { TopbarNavigation } from './header/topbar-navigation/topbar-navigation.component';
import { SiderNavbarComponent } from './sider-navbar/sider-navbar.component';
import * as Styled from './structure-template.style';

const StructureTemplate = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  useTrackingEnrichProperties(); // Enrich tracking properties with current organization and farm

  useEffect(() => {
    dayjs.locale(i18n.language); // change dayjs locale to match i18n language
  }, [i18n.language]);

  useEffect(() => {
    const accessData = getLocalData(StorageKeyOptionsEnum.AccessData);
    setLocalData(StorageKeyOptionsEnum.Tokens, accessData);

    setupAxiosInterceptor(api);

    if (accessData?.access_token) {
      setToken(accessData.access_token);
    }
  }, [user?.id]);

  const isDesktop = useMediaQuery({
    minWidth: MediaQuery.screenSizesCss.desktop,
  });
  const { plannedMaintenance, warningMessage } = useFlags<{
    plannedMaintenance: string;
    warningMessage: string;
  }>();

  const [startDate, endDate] = plannedMaintenance?.split(' ') ?? [];

  return (
    <Styled.LayoutDiv>
      {isDesktop && <TopbarNavigation />}
      <Layout>
        {isDesktop && <SiderNavbarComponent />}
        <Styled.MainContainer>
          {startDate && endDate && (
            <Styled.AlertMaintenance
              message={t('maintenance.planned_maintenance_title', {
                startDate: dayjs(startDate).format('DD/MM/YYYY HH:mm'),
                endDate: dayjs(endDate).format('DD/MM/YYYY HH:mm'),
              })}
              description={t('maintenance.planned_maintenance_subtitle')}
              type="info"
              showIcon
              closable
            />
          )}
          {warningMessage && (
            <Styled.AlertMaintenance
              message={t('maintenance.alert_title')}
              description={warningMessage}
              type="info"
              showIcon
              closable
            />
          )}
          <Styled.ContentDiv>
            <Outlet />
          </Styled.ContentDiv>
        </Styled.MainContainer>
      </Layout>
    </Styled.LayoutDiv>
  );
};

export { StructureTemplate };
